import NoInvoices from './NoInvoices';

export default NoInvoices;
